import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class DownloadFileService {

    constructor() {
    }

    downloadFileFromResponse(response: HttpResponse<Blob>): void {
        // Check for a response body
        if (!response || !response.body) {
            console.error('No response body received');
            return;
        }

        // Extract filename from Content-Disposition header
        const contentDisposition = response.headers.get('Content-Disposition');
        let fileName = 'default-filename.pdf'; // Default filename

        if (contentDisposition) {
            const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (match && match[1]) {
                fileName = match[1].replace(/['"]/g, ''); // Clean up quotes
            }
        }
        console.log('Extracted Filename:', fileName);

        // Create a Blob from the response body
        const file = new Blob([response.body], {type: 'application/pdf'});

        // Create a temporary link element and trigger the download
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(file);
        link.download = fileName;
        link.click();

        // Clean up the URL object and remove the link element
        window.URL.revokeObjectURL(link.href);
        link.remove();
    }

}
